module.exports = __webpack_public_path__ + "img/Pflege-Digitale-Dienste-in-SAP-BSP-auswerten_V2_white.2267abd9.svg";